import { render } from "./PageOverlayLoader.vue?vue&type=template&id=7517a5c8&ts=true"
import script from "./PageOverlayLoader.vue?vue&type=script&lang=ts"
export * from "./PageOverlayLoader.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/apprelax.webweb.works/client/apprelax/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__